import React from "react";
import { Navigate } from "react-router-dom";
import PrivacyV13Document from "./documents/PrivacyV13Document";
import BiztingPrivacyPolicyV14Page from "./BiztingPrivacyPolicyV14Page";
import {
  PRIVACY_V13_EFFECTIVE_AT,
  PRIVACY_V13_NOTICE_START_AT,
  PRIVACY_V14_EFFECTIVE_AT,
  PRIVACY_V14_NOTICE_START_AT,
  getCurrentBiztingPrivacyRoute,
  getScheduledBiztingPrivacyRoute,
} from "./clauseVersionDates";

const CHANGE_ROWS: [string, string][] = [
  ["수집항목 안내방식 개편", "목적별 서술형 안내를 동의 여부 기준 표(동의 없이 처리/동의받아 처리)로 재구성"],
  ["연계정보(CI) 처리 근거 신설", "본인확인 목적의 연계정보(CI) 수집·이용 및 보유기간(즉시 파기), 안전조치 의무 등을 신설 안내"],
  ["제3자 제공 안내 정비", "동의철회 방법 및 절차 명확화"],
  ["안전성 확보조치 강화", "고객사 대시보드 접근통제(MFA), 개인정보 마스킹, 다운로드 통제 등 관리조치 신설"],
  ["자동수집정보 항목 확대", "자동 수집되는 정보에 쿠키, 방문일시, 불량 이용기록 추가"],
  ["보안 담당자 수정", "보안 담당자 수정"],
  ["관심고객 정보 전달 항목 추가", "관심고객 정보 전달(이름, 전화번호, 이메일, 네이버회원 식별정보) 추가"],
  ["광고성 정보 수신(선택) 추가", "신규 서비스·이벤트·프로모션 등 광고성 정보 전달"],
  ["제3자 제공 항목 수정", "제공 목적(관심 고객 정보 전달, 이벤트 안내) 및 법적 근거(제17조 제1항 제1호) 수정"],
];

type BiztingPrivacyPolicyV13PageProps = {
  forceCurrent?: boolean;
};

const BiztingPrivacyPolicyV13Page = ({ forceCurrent = false }: BiztingPrivacyPolicyV13PageProps) => {
  const now = new Date();
  const isV13Effective = now >= PRIVACY_V13_EFFECTIVE_AT;
  const isV14NoticeStarted = now >= PRIVACY_V14_NOTICE_START_AT;
  const isV14Effective = now >= PRIVACY_V14_EFFECTIVE_AT;

  if (!forceCurrent && (isV14Effective || isV14NoticeStarted)) {
    return <BiztingPrivacyPolicyV14Page />;
  }

  if (now < PRIVACY_V13_NOTICE_START_AT) {
    return <Navigate replace to="/clause/privacy" />;
  }

  return (
    <PrivacyV13Document
      mode={isV14Effective ? "previous" : isV13Effective ? "current" : "scheduled"}
      currentVersionRoute={getCurrentBiztingPrivacyRoute(now)}
      scheduledVersionRoute={getScheduledBiztingPrivacyRoute(now)}
      modal={isV13Effective ? undefined : {
        title: "이전 버전 대비 변경사항 요약",
        subtitle: "2026년 6월 5일 시행 버전 → 2026년 9월 28일 시행 버전",
        ctaLabel: "시행 예정 버전 확인하기",
        content: (
          <div className="tw-mb-2">
            <div className="tw-mb-3 tw-flex tw-items-center tw-gap-2 tw-text-[13.5px] tw-font-bold tw-text-[#081f4a]">
              <span className="tw-flex tw-h-5 tw-w-5 tw-items-center tw-justify-center tw-rounded tw-bg-[#1a6ef5] tw-text-[11px] tw-font-bold tw-text-white">1</span>
              개인정보처리방침 변경 내용
            </div>
            <div className="tw-overflow-hidden tw-rounded-lg tw-border tw-border-slate-200">
              <table className="tw-w-full tw-border-collapse tw-text-left tw-text-[13px]">
                <thead>
                <tr className="tw-bg-[#081f4a] tw-text-white">
                  <th className="tw-w-[30%] tw-px-3 tw-py-2.5 tw-font-semibold">변경 항목</th>
                  <th className="tw-px-3 tw-py-2.5 tw-font-semibold">변경 내용</th>
                </tr>
                </thead>
                <tbody>
                {CHANGE_ROWS.map(([label, text], index) => (
                  <tr key={label} className={`tw-border-t tw-border-slate-200 ${index % 2 === 1 ? "tw-bg-slate-50" : ""}`}>
                    <td className="tw-px-3 tw-py-2.5 tw-align-top tw-font-semibold">{label}</td>
                    <td className="tw-px-3 tw-py-2.5">{text}</td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
        ),
      }}
    />
  );
};

export default BiztingPrivacyPolicyV13Page;
